var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paymentPopup"},[(_vm.paymentPopupPg !== 'paymentStatus')?_c('PaymentMethods',{staticClass:"paymentMethods"}):_vm._e(),(_vm.paymentPopupPg === 'paymentStatus')?_c('PaymentStatus',{staticClass:"paymentMethods"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }